<template>
  <div>
    <div class="detail-content-header">
      <nav class="navbar wd-100p pd-0">
        <nav class="nav">
          <div class="nav-link dropdown">
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuBox">
              <li
                class="dropdown-item"
                role="button"
                @click="$emit('on-box-edit', box)"
              >
                Засах
              </li>
              <li
                class="dropdown-item tx-danger"
                role="button"
                @click="$emit('on-box-delete', box)"
              >
                Устгах
              </li>
            </ul>
            <div id="dropdownMenuBox" data-toggle="dropdown" role="button">
              <button class="btn btn-xs btn-outline-primary btn-uppercase">
                <feather type="tool" class="ht-15-f wd-15-f mg-r-5"></feather
                >Тохиргоо
              </button>
              <!-- <span class="nav-link active">{{box.nm}}</span> -->
            </div>
          </div>
          <!-- <span class="nav-link active">{{box.nm}}</span> -->
        </nav>
        <div class="bd-l pd-l-10 mg-l-10">{{ box.nm }}</div>
        <div class="mg-l-auto d-flex">
          <button
            @click="openFormFinder()"
            class="btn btn-xs btn-outline-success btn-uppercase"
          >
            <i class="icon ion-md-add my-3 mg-r-5"></i> Нэмэх
          </button>
        </div>
      </nav>
    </div>
    <div class="pd-x-20 pd-y-15" style="height: calc(100vh - 180px)">
      <div
        v-if="forms.length == 0"
        class="container d-flex justify-content-center ht-100p"
      >
        <div
          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
        >
          <div class="wd-80p wd-sm-300 mg-b-15">
            <img src="assets/svg/folder.svg" class="img-fluid" alt />
          </div>
          <p class="tx-color-03 mg-b-30 tx-center">
            {{ box.nm }} холбогдоогүй байна.
          </p>
        </div>
      </div>
      <div class="row" v-else style="overflow: auto; max-height: calc(100vh - 205px);">
        <div v-for="(f, i) in forms" :key="i" class="col-4">
          <div class="card">
            <div class="card-header">{{ f.nm }}</div>
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between mg-b-10"
              >
                <p
                  class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 tx-medium mg-b-0"
                >
                  Гарчиг
                </p>
                <p class="tx-uppercase tx-11 tx-medium mg-b-0">Утга</p>
              </div>
              <ul class="list-group list-group-flush mg-b-0 tx-13">
                <!-- <li v-if="f.flag==900" class="list-group-item pd-x-0 d-flex justify-content-between">
                    <span class="tx-medium">Үндсэн шалгалт мөн эсэх</span>
                    <span class="tx-rubik text-right" v-if="parentTask.defaultFormId==f.id || setted == f.id"><feather type="award" class="tx-success mg-r-5"></feather>Үндсэн шалгалт</span>
                    <span class="tx-rubik" v-else><button type="button" @click="setAsDefault(f.id, parentTask.id)" class="btn btn-xs btn-primary d-flex"><feather type="award" class="mg-r-5 wd-14-f ht-14-f"></feather>Үндсэн болгох</button></span>
                </li>-->

                <li
                  v-if="f.flag == 500 || f.flag == 900"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Үндсэн шалгалт мөн эсэх</span>
                  <span
                    class="tx-rubik text-right"
                    v-if="courseTask.defaultFormId == f.id || setted == f.id"
                  >
                    <feather type="award" class="tx-success mg-r-5"></feather
                    >Үндсэн шалгалт
                  </span>
                  <span class="tx-rubik" v-else>
                    <button
                      type="button"
                      @click="setAsDefault(f.id, courseTask.id)"
                      class="btn btn-xs btn-light d-flex"
                    >
                      <feather
                        type="award"
                        class="mg-r-5 wd-14-f ht-14-f"
                      ></feather
                      >Үндсэн болгох
                    </button>
                  </span>
                </li>
                <li
                  v-if="f.flag == 900"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Эхлэх</span>
                  <span class="tx-rubik">{{
                    f.sd | moment("YYYY.MM.DD HH:mm:ss, dddd")
                  }}</span>
                </li>
                <li
                  v-if="f.flag == 900"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Дуусах</span>
                  <span class="tx-rubik">{{
                    f.ed | moment("YYYY.MM.DD HH:mm:ss, dddd")
                  }}</span>
                </li>
                <li
                  v-if="f.flag == 500"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Үргэлжлэх хугацаа</span>
                  <span class="tx-rubik">{{ f.minute }} мин</span>
                </li>
                <li
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Асуултын тоо</span>
                  <span class="tx-rubik">{{ f.qCount }}</span>
                </li>
                <li
                  v-if="f.flag == 500"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Үр дүн татах (хураангуй)</span>
                  <span class="tx-rubik">
                    <button
                      @click="lessonAnnualDataPrint(parentTask.id, f.id)"
                      class="btn btn-xs btn-light"
                    >
                      <feather type="download"></feather>
                    </button>
                  </span>
                </li>
                <li
                  v-if="f.flag == 500 || f.flag == 900"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Үр дүн татах (дэлгэрэнгүй)</span>
                  <span class="tx-rubik">
                    <button
                      @click="lessonAnnualDataPrintMore(parentTask.id, f.id)"
                      class="btn btn-xs btn-light"
                    >
                      <feather type="download"></feather>
                    </button>
                  </span>
                </li>
                <li
                  v-if="f.flag == 700"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Үр дүн татах</span>
                  <span class="tx-rubik">
                    <button
                      @click="exportData(f.id)"
                      class="btn btn-xs btn-light"
                    >
                      <feather type="download"></feather>
                    </button>
                  </span>
                </li>
                <li
                  v-if="f.flag == 900"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">И-мэйл мэдэгдэл илгээх</span>
                  <span class="tx-rubik">
                    <a
                      v-if="f.flag == 900"
                      @click="sendIcsMail(f.id)"
                      class="btn btn-xs btn-light"
                      role="button"
                      ><feather type="send" class="ht-20-f wd-20-f"></feather
                    ></a>
                  </span>
                </li>
                <li
                  v-if="f.flag == 700 || f.flag == 500 || f.flag == 900"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Статистик</span>
                  <span class="tx-rubik">
                    <a
                      v-if="f.flag == 500 || f.flag == 900"
                      @click="examReport(f.id)"
                      class="btn btn-xs btn-light"
                      role="button"
                      ><feather
                        type="pie-chart"
                        class="ht-20-f wd-20-f"
                      ></feather
                    ></a>
                    <span class="tx-rubik">
                      <a
                        v-if="f.flag == 500 || f.flag == 900"
                        @click="examReportExport(f.id)"
                        class="btn btn-xs btn-light mg-l-5"
                        role="button"
                        ><feather
                          type="download"
                          class="ht-20-f wd-20-f"
                        ></feather
                      ></a>
                      <span class="tx-rubik">
                        <a
                          :href="`/#/examChart/${f.id}/${f.flag}`"
                          target="_blank"
                          class="btn btn-xs btn-light mg-l-5"
                          role="button"
                          ><feather
                            type="printer"
                            class="ht-20-f wd-20-f"
                          ></feather
                        ></a>
                      </span>
                    </span>
                  </span>
                </li>
                <!-- <li v-if="f.flag==500 || f.flag==900" class="list-group-item pd-x-0 d-flex justify-content-between">
                  <span class="tx-medium">Шалгалтын Статистик Excel татах</span>
                  
                </li> -->
                <!-- <li v-if="f.flag==500 || f.flag==700 || f.flag==900" class="list-group-item pd-x-0 d-flex justify-content-between">
                  <span class="tx-medium">Статистик /хэвлэхээр/</span>
                  <span class="tx-rubik">
                    <a
                      :href="`/#/examChart/${f.id}/${f.flag}`"
                      target="_blank"
                      class="btn btn-xs btn-light"
                      role="button"
                    ><feather type="printer" class="ht-20-f wd-20-f"></feather></a>
                  </span>
                </li> -->
                <li
                  v-if="f.flag == 500"
                  class="list-group-item pd-x-0 d-flex justify-content-between"
                >
                  <span class="tx-medium">Төлбөрийн тохиргоо</span>
                  <span class="tx-rubik">
                    <a
                      @click="formBoxSeetings(f.id)"
                      class="btn btn-xs btn-light"
                      role="button"
                      ><feather
                        type="credit-card"
                        class="ht-20-f wd-20-f"
                      ></feather
                    ></a>
                  </span>
                </li>
              </ul>
            </div>
            <div class="card-footer d-flex justify-content-between">
              <div>
                <span class="tx-rubik">№: {{ f.id }}</span>
              </div>
              <div>
                <a
                  class="btn btn-xs btn-danger text-white"
                  @click="unlinkConfirm(f)"
                  title="холболт салгах"
                  ><feather type="trash-2"></feather
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-overlay :show="busy" no-wrap>
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
              >Үгүй</b-button
            >
            <b-button variant="outline-success" @click="unlinkForm()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>

    <form-finder
      v-if="showFinder"
      :prms="finderParams"
      @on-form-selected="linkForm"
      @on-close="showFinder = false"
    />
    <send-ics-mail
      @on-hide="icsMailModal.show = false"
      :isShow.sync="icsMailModal.show"
      :prms.sync="icsMailModal.prms"
      :key="icsMailModal.key"
    ></send-ics-mail>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  components: {
    formFinder: () => ({
      component: import("@/views/modules/form/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    sendIcsMail: () => ({
      component: import("@/components/task/detail/special/sendIcsMail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    parentTask: {
      type: Object,
      default: () => {}
    },
    box: {
      type: Object,
      default: () => {}
    },
    prms: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      courseTask: null,
      forms: [],
      processing: false,
      busy: false,
      processingId: 0,
      showFinder: false,
      finderParams: {
        mode: 50,
        objectTypeId: null
      },
      setted: 0,
      icsMailModal: {
        show: false,
        prms: {
          courseId: 0,
          objectId: 0,
          boxId: 0,
          objectTypeId: 0
        },
        key: 0
      },
      formPayment: {
        modal: false,
        formId: 0,
        boxId: 0
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    formBoxSeetings(id) {
      this.$emit("on-form-setting", { id: id, boxId: this.box.id });
      // this.formPayment.formId= id;
      // this.formPayment.boxId= this.box.id;
      // this.formPayment.modal= true;
    },
    examReport(id) {
      this.$emit("on-exam-report", id);
      //console.log(id);
    },
    examReportExport(id) {
      this.$emit("on-exam-report-export", id);
      //console.log(id);
    },
    sendIcsMail(id) {
      this.icsMailModal.prms.courseId = this.parentTask.id;
      this.icsMailModal.prms.objectId = id;
      this.icsMailModal.prms.boxId = this.box.id;
      this.icsMailModal.prms.objectTypeId = 116;
      this.icsMailModal.show = true;
      this.icsMailModal.key++;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    exportData(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        data: { id: id },
        api: { method: "post", url: "form/exportData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$emit("on-attach", res.data.file.id);
        }
      });
    },
    lessonAnnualDataPrint(id, formId) {
      //learn/lessonAnnualDataPrint?id=1563179
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        params: { id: id, formId: formId },
        api: { method: "get", url: "v2/Learn/lessonAnnualDataPrint" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$emit("on-attach", res.data.file.id);
        }
      });
    },
    lessonAnnualDataPrintMore(id, formId){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        params: { id: id, examId: formId },
        api: { method: "get", url: "Form/GetExamFilledDetailedDataExport" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res);
          this.$emit("on-attach", res.data.file.id);
        }
      });
    },
    setAsDefault(examId, courseId) {
      //console.log("set as default", examId, courseId);
      request({
        data: { examId: examId, courseId: courseId },
        api: { method: "POST", url: "v2/Learn/SetAsDefaultExam" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.setted = examId;
          this.$emit("on-reload-parent", this.box.id);
        }
      });
    },
    init() {
      switch (this.box.ot) {
        case 116:
          this.finderParams.objectTypeId = 900;
          break;
        case 117:
          this.finderParams.objectTypeId = 800;
          break;
        case 389:
          this.finderParams.objectTypeId = 700;
          break;
        case 503:
          this.finderParams.objectTypeId = 700;
          break;
        case 416:
          this.finderParams.objectTypeId = 500;
          break;
        default:
          break;
      }
      let url = "Form/BoxInFormList";
      if (this.finderParams.objectTypeId == 900) {
        url = "Form/BoxInExamList";
      }
      request({
        params: { id: this.box.id },
        api: { method: "get", url: url },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('BoxInExamList', res.databox.formCount);
          this.$emit("update-box-count", {
            boxId: this.box.id,
            count: res.data.box.formCount
          });
          this.forms = res.data.forms;
          this.courseTask = res.data.courseTask;
          this.$emit("box-loaded");
        }
      });
    },
    linkForm(f) {
      //console.log(f);
      if (f.length) {
        f.forEach(x => {
          request({
            data: { boxId: this.box.id, formId: x },
            api: { method: "POST", url: "Box/AttachForm" },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.showFinder = false;
              this.init();
            } else {
              this.showFinder = false;
            }
          });
        });
      }
    },
    unlinkConfirm(f) {
      this.processingId = f.id;
      this.busy = true;
    },
    unlinkForm() {
      this.processing = true;
      request({
        data: { boxId: this.box.id, formId: this.processingId },
        api: { method: "POST", url: "Box/DetachForm" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.processing = false;
          this.busy = false;
          this.init();
        }
      });
    },
    openFormFinder() {
      this.showFinder = true;
    }
  }
};
</script>

<style></style>
